<div class="search-input-wrap" [class.search-input-wrap--disabled]="disabled">
  <ng-container *ngIf="prefixImageSrc; else prefixIcon">
    <img
      class="search-prefix-icon"
      [src]="prefixImageSrc"
      [alt]="prefixAlt"
      width="20"
      height="20" />
  </ng-container>
  <ng-template #prefixIcon>
    <mat-icon class="search-prefix-mat-icon">search</mat-icon>
  </ng-template>

  <input
    type="text"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    autocomplete="off"
    [attr.aria-label]="ariaLabel || placeholder"
    (input)="onInput($event)"
    (blur)="onBlur()" />

  <button
    type="button"
    class="clear-btn"
    *ngIf="value"
    [disabled]="disabled"
    (click)="clear()"
    [attr.aria-label]="clearAlt">
    <ng-container *ngIf="clearImageSrc; else clearIcon">
      <img [src]="clearImageSrc" height="20" width="20" [alt]="clearAlt" />
    </ng-container>
    <ng-template #clearIcon>
      <mat-icon>close</mat-icon>
    </ng-template>
  </button>
</div>

